import '../admin-shared.css'

import { PageHeader, Spinner } from '../../../Components'
import { useCQuery } from '../../../Services'
import { cap } from '../../../State'
import { translations } from '../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

export const AdminSettings = () => {
  const { isPending, isError, error } = useCQuery(['system'])

  if (isPending) return <Spinner />

  return (
    <div className="admin-page--narrow">
      <PageHeader title={t.impostazioniSistema || 'Impostazioni Sistema'} />

      <div className="ncard">
        <div className="ncard__head">
          <div className="ncard__ico">
            <i className="pi pi-cog" style={{ fontSize: 16 }} />
          </div>
          <div>
            <h3 className="ncard__title">{t.impostazioniSistema || 'Impostazioni Sistema'}</h3>
          </div>
        </div>
        <div className="ncard__body">
          {isError ? (
            <p style={{ color: 'var(--danger)', fontSize: 14, margin: 0 }}>
              {t.errore || 'Errore'}: {error?.message || String(error)}
            </p>
          ) : (
            <p style={{ color: 'var(--ink-500)', fontSize: 14, margin: 0 }}>
              {t.nessunaImpostazione || 'Nessuna impostazione configurabile al momento.'}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
